// import axios from "axios";

// export function getRequest(url, headerToken, subscriptionKey) {
//     const config = {
//         headers: { Authorization: `Bearer ${headerToken}`,"Ocp-Apim-Subscription-Key": subscriptionKey  },
//     };
//     const data = (axios.get(url, config))
//     return data
// }
// import axios from "axios";

// export function getRequest(url, email, flag) {
//   const config = {
//     headers: { "Access-Control-Allow-Origin": true },
//   };
//   if (flag) {
//     url += `&email=${encodeURIComponent(email.data)}`;
//   }
//   const data = axios.get(url, config);
//   return data;
// }

// import axios from "axios";
// import CryptoJS from "crypto-js";

// const SECRET_KEY = "1234567890abcdef1234567890abcdef";

// function decryptFunction(ciphertext, key) {
//   // Decrypt
//   let bytes = CryptoJS.AES.decrypt(ciphertext, key);
//   let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
//   console.log("hello data ", decryptedData);
//   return decryptedData;
// }

// export async function getRequest(url, email, flag) {
//   const config = {
//     headers: { "Access-Control-Allow-Origin": true },
//   };
//   if (flag) {
//     url += `&email=${encodeURIComponent(email.data)}`;
//   }
//   console.log("i m here");
//   const data = await axios.get(url, config);
//   // console.log("data", data.data);
//   const decrypteddata = decryptFunction(data.data, SECRET_KEY);
//   console.log("scarlet", decrypteddata);
//   return decrypteddata;
// }

import axios from "axios";
import CryptoJS from "crypto-js";
import { notify } from "../../common/Helper/notification";

const SECRET_KEY = "1234567890abcdef1234567890abcdef";

function decryptFunction(ciphertext, key) {
  let bytes = CryptoJS.AES.decrypt(ciphertext, key);
  let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  console.log("hello data ", decryptedData);
  return decryptedData;
}



export const handleLogout = () => {
  // Show message
  notify.error("Session Expired");

  // Clear auth data
  localStorage.removeItem("authToken");
  localStorage.removeItem("loginState");
  sessionStorage.removeItem("authToken");

  // Redirect to login page
  window.location.href = "/";
};

export async function getRequest(url, email, flag) {
  const authToken = localStorage.getItem("authToken");

  const config = {
    headers: {
      "Access-Control-Allow-Origin": true,
      Authorization: authToken ? `Bearer ${authToken}` : "",
    },
  };

  if (flag) {
    url += `&email=${encodeURIComponent(email.data)}`;
  }


  let response;
  try {
    response = await axios.get(url, config);
  } catch (error) {
  if (error.response && error.response.status === 401){
      console.log("Token expired");
      handleLogout();
      return;
    }
    throw error;
  }

  const decrypteddata = decryptFunction(response.data, SECRET_KEY);
  console.log("scarlet", decrypteddata);

  return decrypteddata;
}
